<template>
  <div id="centreLeft8">
    <el-dialog title="出入库历史" :visible.sync="dialogFormVisible" width="30%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column v-for="(item,index) in data" :key="index" :prop="item['prop']" :label="item['label']" :width="item['width']">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <div @click="checkHistory">
      <div style="color: #fff;font-size: 16px;margin-left: 2.9rem;">蜀地机组出勤情况</div>
      <dv-scroll-board ref="scrollBoard" :config="config" style="width:6.5rem;height:2.2rem;margin-top: .2rem;" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      data:[
        {prop: 'today_time',label: '时间',width: '130'},
        {prop: '出/备勤',label: '出/备勤'},
        {prop: '过夜机组',label: '过夜机组'},
      ],
      config: {
        header: ['出/备勤', '过夜机组'],
        data: [],
        headerBGC: '#0d1120',
        oddRowBGC: '#0d1120',
        evenRowBGC: '#0d1120',
      }
    };
  },
  components: {

  },
  created() {
    setTimeout(() => {
      this.getData(this.$store.state['storageList'])
    }, 100)
  },
  computed: {
    listData() {
      return this.$store.state['storageList']
    }
  },
  watch: {
    listData(data) {
      this.getData(data)
    }
  },
  methods: {
    checkHistory(){
      axios({
        url: `http://115.190.8.169:5000/get_storage_data`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.tableData = res.data
        }
      })
      this.dialogFormVisible = true
    },
    getData(data) {
      this.config.data = []
      data.forEach(item => {
        this.config.data.push([`<span style="background: blue;padding: 0px 5px;">${item['入库']}</span>`,`<span style="background: blue;padding: 0px 5px;">${item['出库']}</span>`])
      })
      this.config = { ...this.config };
      // this.$refs['scrollBoard'].updateRows(this.config.data)
    },
  },
};
</script>

<style lang="scss" scoped>
#centreLeft8 {
  margin-right: 0.2rem;
  box-sizing: border-box;
  padding: 0.2rem 0;
  height: 4.5125rem;
  min-width: 11.6rem;
  border-radius: 0.0625rem;

  .bg-color-black {
    height: 4.5125rem;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
    font-size: 0.18rem;
  }

  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;

    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>